import React from "react";
import { Check } from "lucide-react";

/**
 * Final OG image render — exact 1200×630 canvas.
 * Route: /og-final  → screenshot this at viewport 1200×630 to save as og-image.jpg
 */

const CHECK = (
  <Check aria-hidden className="w-5 h-5" style={{ color: "#023CFA" }} strokeWidth={3} />
);

function LabelCard({ label }) {
  return (
    <div
      className="rounded-2xl border border-black/5 px-6 py-5 flex items-center justify-between gap-4"
      style={{ background: "#FFFFFF", width: 320, boxShadow: "0 20px 40px -20px rgba(0,0,0,0.15)" }}
    >
      <div className="text-[16px] font-semibold tracking-tight text-neutral-900" style={{ letterSpacing: "-0.01em" }}>{label}</div>
      {CHECK}
    </div>
  );
}

function ReserveFundCard() {
  return (
    <div
      className="rounded-2xl border border-black/5 px-6 py-4"
      style={{ background: "#FFFFFF", width: 300, boxShadow: "0 20px 40px -20px rgba(0,0,0,0.15)" }}
    >
      <div className="flex items-center justify-between">
        <div className="text-[13px] text-neutral-500">Reserve Fund</div>
        <div className="flex items-center gap-1.5 text-[12px] font-semibold" style={{ color: "#023CFA" }}>
          <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#023CFA" }} />
          Live
        </div>
      </div>
      <div className="mt-2 text-[28px] font-semibold tracking-tight text-neutral-900">$1,284,320</div>
      <div className="mt-3 h-1.5 w-full rounded-full bg-neutral-200 overflow-hidden">
        <div className="h-full rounded-full" style={{ background: "#023CFA", width: "72%" }} />
      </div>
      <div className="mt-2 text-[12px] text-neutral-500">72% of 2026 target</div>
    </div>
  );
}

export default function OgFinal() {
  return (
    <div
      data-testid="og-final"
      style={{
        width: 1200,
        height: 630,
        background: "#FFFFFF",
        position: "relative",
        overflow: "hidden",
        fontFamily: `"SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif`,
      }}
    >
      {/* Top-left: 24/7 Communication (kept in place) */}
      <div style={{ position: "absolute", top: 40, left: 40 }}>
        <LabelCard label="24/7 Communication" />
      </div>

      {/* Top-right: Reserve Fund (dropped slightly for asymmetry) */}
      <div style={{ position: "absolute", top: 90, right: 40 }}>
        <ReserveFundCard />
      </div>

      {/* Bottom-right: Proactive Property Management — left edge starts near end of "r" in "PropHero" */}
      {/* Logo centered at ~x=600, PropHero wordmark ~width 380 at height 140 → "r" ends ~x=690.
         Card is 320px wide, so left = 690 → right offset = 1200 - 690 - 320 = 190 */}
      <div style={{ position: "absolute", bottom: 60, right: 190 }}>
        <LabelCard label="Proactive Property Management" />
      </div>

      {/* PropHero logo — dead centre */}
      <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <img src="/prophero-logo.png" alt="PropHero" style={{ height: 140 }} />
      </div>
    </div>
  );
}
